




































































































































































import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import Viewpoints from '@/store/modules/Viewpoints';
import Decisions from '@/store/modules/Decisions';
import Choices from '@/store/modules/Choices';
import CardTitle from '@/components/common/CardTitle.vue';
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import { REQUIRED } from '@/rules';
import _ from 'lodash';
import DescriptionEditor from '@/components/common/DescriptionEditor.vue';
import {
    ResourceList,
    ChoiceList,
    ChoiceListItem,
    ListType,
    ViewpointList,
} from '@/api/model/ResourceList';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import ViewpointListInputDialog from '@/components/Lists/ViewpointListInputDialog.vue';
import { watch } from 'fs';
import { Viewpoint } from '@/api/model/Viewpoint';

const viewpointsModule = getModule(Viewpoints);
const choicesModule = getModule(Choices);
const decisionsModule = getModule(Decisions);
const workspaceModule = getModule(WorkspaceOptions);

@Component({
    components: {
        ViewpointListInputDialog,
        CardTitle
    },
})
export default class ViewpointListSelection extends Vue {
    @Prop({default: false, type: Boolean})
    listActivator!: boolean

    @Prop({default: false, type: Boolean})
    allowEmptyViewpoints!: boolean

    @Prop({default: '', type: String})
    icon!: string

    @Prop({default: '', type: String})
    btnMessage!: string

    @Prop({default: ()=>([]), type: Array})
    viewpointsFromParent!: Viewpoint[]

    private REQUIRED = REQUIRED;
    private showLists = true;
    private displayViewpoints = [];
    private generating = false;
    // private storedLists = []
    private type: any = { VIEWPOINT: 'VIEWPOINT' };
    private loading = false;
    private listId: string = '';
    private alert = false;
    private alertText = 'Create';
    private alertType = 'success';
    private show: boolean = false;
    private selectedItem = {};
    private selectedLists = [];

    $refs!: {
        form: HTMLFormElement;
    };

    get storedLists() {
        return _.values(decisionsModule.decisionLists).filter(
            (list: any) => list.type === 'VIEWPOINT'
        );
    }
    
    get activeViewpointLists(){
        return workspaceModule.activeViewpointLists;
    }
    
    get selectedChoiceId() {
        return choicesModule.selectedChoiceId;
    }

    get choicesList() {
        return choicesModule.choicesList;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get previouslyCreatedLists() {
        if (this.selectedDecision)
            return VIEWPOINT_API.getDecisionLists(this.selectedDecision.decisionId);
    }

    get choices() {
        return choicesModule.choices;
    }

    get lists() {
        return this.storedLists;
    }

    get viewpoints() {
        return viewpointsModule.decisionViewpointsMap || [];
    }

    get viewpointsList() {
        return _.sortBy(viewpointsModule.decisionViewpoints || [], 'name');
    }

    get unfilteredViewpointsList() {
        return _.sortBy(viewpointsModule.unfilteredViewpoints || [], 'name');
    }

    get unfilteredViewpoints() {
        return viewpointsModule.unfilteredViewpointsMap || [];
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel;
    }

    get pluralViewpointLabel() {
        return decisionsModule.pluralViewpointLabel;
    }

    @Watch('show')
    onShowChange() {
        if(this.show && !this.listActivator) {
            this.setSelectedLists();
            //Init lists from workspace options
        } else {
            // this.$refs.form.reset();
        }
    }

    @Watch('storedLists')
    @Watch('activeViewpointLists')
    private onListChange(){
        this.setSelectedLists();
    }
    
    
    private async submit() {
        let submitLists: string[] = this.storedLists!.filter(
            (list: ViewpointList, index) => this.selectedLists[index]
        ).map((list: any) => list.listId);
        if(this.listActivator) {
            this.$emit('save', submitLists);
            this.show = false;
            return
        }
        if (submitLists) {
            workspaceModule.updateSavedViewpointLists(submitLists);
        }
        else{
            workspaceModule.updateSavedViewpointLists([]);

        }
        this.show = false;
    }


    private setSelectedLists(){
        this.selectedLists = this.storedLists && this.activeViewpointLists
            ? this.storedLists.map((list: any) =>
                  this.activeViewpointLists.includes(list.listId)
              )
            : [];
    }

    private async clearSelections() {
        this.selectedLists=[];
    }

    // private async refreshLists() {
    //     if(this.showLists && this.selectedDecision) {
    //         this.loading = true;
    //         this.storedLists = await VIEWPOINT_API.getDecisionLists(this.selectedDecision.decisionId);
    //         this.storedLists = this.storedLists.filter((list: ResourceList) => list.type === 'VIEWPOINT')
    //         this.loading = false;
    //     }
    // }

    private cancel() {
        this.listId = '';
        this.show = false;
        // this.$refs.form.reset();
        // this.displayViewpoints = [];
        // this.selectedLists = [];
    }

    // private clear() {
    //     // this.displayViewpoints = [];
    //     this.listId = '';
    // }

    private createAlert() {
        setTimeout(() => {
            this.alert = false;
        }, 4000);
    }

    @Watch('selectedLists')
    onChangeSelectedLists() {
        this.displayViewpoints = this.storedLists.filter(
            (list: ViewpointList, index) => this.selectedLists[index]
        );
    }
}
